__turbopack_context__.v({
  "attachmentExt": "Paragraph-module__5TKhOW__attachmentExt",
  "attachmentLink": "Paragraph-module__5TKhOW__attachmentLink",
  "attachmentSize": "Paragraph-module__5TKhOW__attachmentSize",
  "attachments": "Paragraph-module__5TKhOW__attachments",
  "attachmentsHeading": "Paragraph-module__5TKhOW__attachmentsHeading",
  "attachmentsList": "Paragraph-module__5TKhOW__attachmentsList",
  "bigPhoto": "Paragraph-module__5TKhOW__bigPhoto",
  "bigPhotoButton": "Paragraph-module__5TKhOW__bigPhotoButton",
  "bigPhotoDescription": "Paragraph-module__5TKhOW__bigPhotoDescription",
  "bigPhotoFigure": "Paragraph-module__5TKhOW__bigPhotoFigure",
  "bigPhotoImg": "Paragraph-module__5TKhOW__bigPhotoImg",
  "blogPost": "Paragraph-module__5TKhOW__blogPost",
  "blogPostBody": "Paragraph-module__5TKhOW__blogPostBody",
  "blogPostCategory": "Paragraph-module__5TKhOW__blogPostCategory",
  "blogPostImg": "Paragraph-module__5TKhOW__blogPostImg",
  "blogPostMeta": "Paragraph-module__5TKhOW__blogPostMeta",
  "blogPostName": "Paragraph-module__5TKhOW__blogPostName",
  "blogPosts": "Paragraph-module__5TKhOW__blogPosts",
  "box": "Paragraph-module__5TKhOW__box",
  "boxBody": "Paragraph-module__5TKhOW__boxBody",
  "boxCta": "Paragraph-module__5TKhOW__boxCta",
  "boxImage": "Paragraph-module__5TKhOW__boxImage",
  "boxText": "Paragraph-module__5TKhOW__boxText",
  "boxTitle": "Paragraph-module__5TKhOW__boxTitle",
  "boxes": "Paragraph-module__5TKhOW__boxes",
  "boxesThree": "Paragraph-module__5TKhOW__boxesThree",
  "boxesTwo": "Paragraph-module__5TKhOW__boxesTwo",
  "colsThree": "Paragraph-module__5TKhOW__colsThree",
  "colsTwo": "Paragraph-module__5TKhOW__colsTwo",
  "contactForm": "Paragraph-module__5TKhOW__contactForm",
  "contactFormActions": "Paragraph-module__5TKhOW__contactFormActions",
  "contactFormError": "Paragraph-module__5TKhOW__contactFormError",
  "contactFormIntro": "Paragraph-module__5TKhOW__contactFormIntro",
  "contactFormRow": "Paragraph-module__5TKhOW__contactFormRow",
  "empty": "Paragraph-module__5TKhOW__empty",
  "flexCol": "Paragraph-module__5TKhOW__flexCol",
  "flexRow": "Paragraph-module__5TKhOW__flexRow",
  "flexRowReverse": "Paragraph-module__5TKhOW__flexRowReverse",
  "gallery": "Paragraph-module__5TKhOW__gallery",
  "galleryItem": "Paragraph-module__5TKhOW__galleryItem",
  "galleryItemDescription": "Paragraph-module__5TKhOW__galleryItemDescription",
  "galleryItemSingle": "Paragraph-module__5TKhOW__galleryItemSingle",
  "galleryItemStack": "Paragraph-module__5TKhOW__galleryItemStack",
  "galleryStack": "Paragraph-module__5TKhOW__galleryStack",
  "galleryWide": "Paragraph-module__5TKhOW__galleryWide",
  "htmlText": "Paragraph-module__5TKhOW__htmlText",
  "list": "Paragraph-module__5TKhOW__list",
  "mapLoading": "Paragraph-module__5TKhOW__mapLoading",
  "mapWrap": "Paragraph-module__5TKhOW__mapWrap",
  "mediaCol": "Paragraph-module__5TKhOW__mediaCol",
  "paragraph": "Paragraph-module__5TKhOW__paragraph",
  "paragraphName": "Paragraph-module__5TKhOW__paragraphName",
  "paragraphNameCentered": "Paragraph-module__5TKhOW__paragraphNameCentered",
  "paragraphSubName": "Paragraph-module__5TKhOW__paragraphSubName",
  "paragraphUnsupported": "Paragraph-module__5TKhOW__paragraphUnsupported",
  "root": "Paragraph-module__5TKhOW__root",
  "textCol": "Paragraph-module__5TKhOW__textCol",
  "videoFrame": "Paragraph-module__5TKhOW__videoFrame",
  "videoMissing": "Paragraph-module__5TKhOW__videoMissing",
});
